import React from "react"
import Banner from "./banner"
import Content from "./content-section"
import SearchList from "./search-list"
import Form from "./form"
import FeaturedItems from "./featured-items"
import Profile from "./profile"
import Gallery from "./gallery"
import Accordions from "./accordions"
import Table from "./table"

const Sections = ({ props, location }) => {
  const { sections } = props
  const sectionsLength = sections.length
  if (!sections || !sectionsLength) {
    return null
  }
  let mobileIndex = -1

  return (
    <>
      {sections.map((section, index) => {
        const fieldGroupName = section?.fieldGroupName
        if (section.hideOnMobile !== true) { mobileIndex++ }
        if (fieldGroupName) {
          return fieldGroupName.includes("Customsections_Sections_Banner") ? (
            <Banner props={section} index={index} key={index} mobileIndex={mobileIndex} />
          ) : fieldGroupName.includes("Customsections_Sections_Content") ? (
            <Content props={section} index={index} key={index} mobileIndex={mobileIndex} lastSection={index === sectionsLength - 1} />
          ) : fieldGroupName.includes("Customsections_Sections_FeaturedItems") ? (
            <FeaturedItems props={section} index={index} key={index} mobileIndex={mobileIndex} lastSection={index === sectionsLength - 1} location={location} />
          ) : fieldGroupName.includes("Customsections_Sections_Profile") ? (
            <Profile props={section} key={index} />
          ) : fieldGroupName.includes("Customsections_Sections_SearchList") ? (
            <SearchList props={section} key={index} />
          ) : fieldGroupName.includes("Customsections_Sections_Form") ? (
            <Form props={section} key={index} />
          ) : fieldGroupName.includes("Customsections_Sections_Gallery") ? (
            <Gallery props={section} key={index} index={index} />
          ) : fieldGroupName.includes("Customsections_Sections_Accordions") ? (
            <Accordions props={section} key={index} index={index} />
          ) : fieldGroupName.includes("Customsections_Sections_Table") ? (
            <Table props={section} key={index} />
          ) : null
        } else {
          return null
        }
      })}
    </>
  )
}

export default Sections
